import { WebPlugin } from '@capacitor/core';
export class CapacitorScrollSwipeBounceIosWeb extends WebPlugin {
    async echo(options) {
        console.log('LOGGING OPTIONS', options);
        return options;
    }
}
//# sourceMappingURL=web.js.map